module.exports = __webpack_public_path__ + "img/11.ce704245.png";